<template>
    <ion-toolbar>
        <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="welcome_text">
            <span>Welcome to</span>
            <img src="@/assets/img/logo_text.svg" alt="" class="logo_text">
            <div class="select_type_text">
                <span>Before you start exploring, we'd like to learn a bit more about you to tailor your experience and ensure you get the most out of the system.</span>
            </div>
        </div>

        <div class="buttons_wrapper">
            <el-button type="transparent" class="bg-white" @click="goNext()">
                Continue
            </el-button>
           
        </div>
    </div>
</template>


<script>
    import {
        onMounted,
        onUnmounted,
    } from 'vue';

    import {
        IonToolbar,
    } from '@ionic/vue';

    import {
        useRouter,
    } from 'vue-router'

    export default {
        components: {
            IonToolbar
        },
        setup() {
            const $router = useRouter()
            const goBack = () => {
                $router.push({
                    name: 'search',
                });
            };
           
            const goNext = () => {
                $router.push({
                    name: 'additional_onboard_locum_job_seeker',
                })
            }

            onMounted(() => {
                $('body').addClass('background_blue');
            });

            onUnmounted(() => {
                $('body').removeClass('background_blue');
            });
            return {
                goNext,
                goBack
            }
        }
    }
</script>